import { Clock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/** "Still there?" modal shown for the final 2 minutes before the idle sign-out. */
export default function IdleWarning() {
  const { idleRemaining, staySignedIn, logout } = useAuth();
  if (idleRemaining == null) return null;
  const secs = Math.max(0, Math.ceil(idleRemaining / 1000));
  const mm = String(Math.floor(secs / 60)).padStart(1, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4" data-testid="idle-warning" role="alertdialog" aria-modal="true">
      <div className="w-full max-w-sm bg-[#f5f2eb] border-2 border-[#0a0a0a] shadow-[8px_8px_0_0_#c72c2c] p-6">
        <div className="bm-eyebrow text-[#c72c2c] flex items-center gap-2"><Clock size={12} /> Still there?</div>
        <h2 className="text-xl font-semibold mt-2">You'll be signed out in</h2>
        <div className="font-mono-bm text-5xl font-bold tabular-nums mt-2" data-testid="idle-countdown">{mm}:{ss}</div>
        <p className="text-sm text-neutral-600 mt-3 leading-relaxed">
          No activity for almost 2 hours. Anything you're typing into Ask the Data will be lost when the session closes.
        </p>
        <div className="mt-5 flex flex-col sm:flex-row gap-2">
          <button
            onClick={staySignedIn}
            autoFocus
            data-testid="idle-stay-button"
            className="flex-1 min-h-[44px] px-4 bm-eyebrow bg-[#0a0a0a] text-[#f5f2eb] border border-[#0a0a0a] hover:opacity-90"
          >
            Stay signed in
          </button>
          <button
            onClick={logout}
            data-testid="idle-signout-button"
            className="flex-1 min-h-[44px] px-4 bm-eyebrow border border-[#0a0a0a] hover:bg-[#0a0a0a]/5"
          >
            Sign out now
          </button>
        </div>
      </div>
    </div>
  );
}
